import React from 'react';
import CreateContent from './CreateContent';

const EditContent = props => <CreateContent isEdit {...props} />;

export default EditContent;
